import axios from 'axios';

// Criando uma instância do axios com a baseURL a partir do .env
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,  // URL da API configurada no .env

  withCredentials: false, 
});

export default api;

